import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './top.styl'

export default class Top extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    onClick: PropTypes.func
  }

  render() {
    return (
      <div
        onClick={this.props.onClick}
        className={[styles.wrap, this.props.className].join(' ')}
      >
        {this.props.children}
      </div>
    )
  }
}
